// extracted by mini-css-extract-plugin
export default {"section":"CommunityComponent_section__A5I2T","linksContainer":"CommunityComponent_linksContainer__zMuRr","img":"CommunityComponent_img__0uxFU"};